import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscriptionPlanDetail } from '../../services/subscription.service';

@Component({
  selector: 'app-pricing-detail-modal',
  imports: [CommonModule],
  templateUrl: './pricing-detail-modal.component.html',
  styleUrl: './pricing-detail-modal.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PricingDetailModalComponent {
  planDetail = input.required<SubscriptionPlanDetail>();
  close = output<void>();
  selectPlan = output<SubscriptionPlanDetail>();

  onClose() {
    this.close.emit();
  }

  onSelectPlan() {
    this.selectPlan.emit(this.planDetail());
  }

  formatPrice(price: number): string {
    return price.toFixed(2).replace('.', ',');
  }
}
